package com.xtream.composeapp.viewmodel.livetv

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import androidx.paging.Pager
import androidx.paging.PagingConfig
import androidx.paging.PagingData
import androidx.paging.cachedIn
import androidx.paging.map
import com.xtream.composeapp.SharedBuildKonfig
import com.xtream.data_kmp.AllConst
import com.xtream.data_kmp.AllConst.PAGING_PAGE_SIZE
import com.xtream.data_kmp.FavoriteLiveStreamEntity
import com.xtream.data_kmp.WatchedLiveStreams
import com.xtream.data_kmp.db.repo.LiveStreamsRepository
import com.xtream.data_kmp.db.repo.WatchedLiveRepository
import com.xtream.data_kmp.dto.BaseStream
import com.xtream.data_kmp.dto.CategoryWithStream
import com.xtream.data_kmp.dto.LiveCategory
import com.xtream.data_kmp.dto.LiveStream
import com.xtream.data_kmp.remote.createApiService
import kotlinx.coroutines.CoroutineExceptionHandler
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.launch
import kotlinx.coroutines.withContext
import kotlin.time.Clock


open class LiveStreamsViewModel (
    internal val tvStreamsRepo: LiveStreamsRepository,
    private val watchedStreamsRepo: WatchedLiveRepository,
) : ViewModel() {

    suspend fun getStreamById(streamId: Int?): LiveStream? = tvStreamsRepo.getStreamById(streamId)




fun clearWatched() = viewModelScope.launch(Dispatchers.Default) { watchedStreamsRepo.deleteAll() }
    suspend fun getCategory(categoryId: Int?): LiveCategory? = tvStreamsRepo.getCategory(categoryId)
    fun getAllLiveCategoriesFlow(): Flow<List<LiveCategory>> =
        tvStreamsRepo.getCategoriesAsFlow()
            .map { list ->
                val requiredList = list ?: emptyList()
                AllConst.defaultCategories + requiredList
            }

    val liveCategoriesFlow: Flow<List<LiveCategory>> =
        tvStreamsRepo.getCategoriesAsFlow()
            .map { it}
    /**
     * gets Movies Categories as Flow<PagingData<VodCategory>>
     * @return Flow<PagingData<VodCategory>>
     */
    val liveCategoriesPagingFlow : Flow<PagingData<LiveCategory>> = tvStreamsRepo.categoriesPagingFlow.cachedIn(viewModelScope)



    @ExperimentalStdlibApi
    val  categoriesPagerWithTvStreams = Pager(
        config = PagingConfig(
            pageSize = AllConst.PAGING_MIN_PAGE_SIZE,
            enablePlaceholders = false,
        ),
    pagingSourceFactory = {
        val a=        tvStreamsRepo.getPagedCategoriesWithStreams()


        a

    }
    ).flow.map {
        it.map { sizedCategory->
            CategoryWithStream<LiveStream, LiveCategory>(
                category = sizedCategory.category,
                size = sizedCategory.size,
                streams = tvStreamsRepo.all(sizedCategory.category.categoryId)
            )
        }
    }.cachedIn(viewModelScope)

        @ExperimentalStdlibApi
    val  getCategoriesWithTvChannelsPager =
        Pager(
        config = PagingConfig(
            pageSize = AllConst.PAGING_MIN_PAGE_SIZE,
            enablePlaceholders = false,
        ),
        pagingSourceFactory = {

            tvStreamsRepo.getCategoriesAsPagingFlow()
        }
    ).flow.map { categories ->
       // val startTime =   System.nanoTime()


      val res= categories.map {
           Pair(it,
               tvStreamsRepo.getStreamsAsFlow(it.categoryId, limit = 15)
           )
        }
       // Log.e("Measure", "TASK took : " +  ((System.nanoTime()-startTime)/1000000)+ "mS")

                res
    }.cachedIn(viewModelScope)

   suspend fun getFav(): List<LiveStream>? =
        tvStreamsRepo.getFavorites()

    fun getFavFlow() =
        tvStreamsRepo.getFavoritesAsFlow()



    /**
     * adds stream to Favorites Table
     * @property  stream stream item to be added
     **/
    suspend fun addToFavorites(stream: BaseStream) {
        withContext(Dispatchers.Default) {
            val fav = FavoriteLiveStreamEntity().apply {
                this.streamId=  stream.streamId
                this.sortOrder=   Clock.System.now().toEpochMilliseconds()
            }
            tvStreamsRepo.insertFavorite(fav)
        }
    }

    /**
     * removes stream to Favorites Table
     * @property  stream stream item to be removed
     **/
    suspend fun deleteFromFavorites(stream: BaseStream, onRemoved: () -> Unit) {
        withContext(Dispatchers.Default) {
            val fav = FavoriteLiveStreamEntity().apply {this.streamId= stream.streamId }
            tvStreamsRepo.deleteFavorite(fav)
            onRemoved.invoke()
        }
    }


    fun updateFavoriteStatus(stream: BaseStream?, onDone: (Boolean) -> Unit={}){
        viewModelScope.launch {
            if (stream == null) return@launch
            if (tvStreamsRepo.isFavorite(stream.streamId))
                deleteFromFavorites(stream) {
                    onDone.invoke(false)
                }
            else {
                addToFavorites(stream)
                onDone.invoke(true)

            }
        }

    }



/**
 * gets Paginated Movies for given category Id
 * @property  categoryId id of the category
 * @property  searchQuery  id of the category
 * @return  Flow<PagingData<[com.xtream.data.dto.LiveStream]>>
 */
fun getPagedLiveStreamsFlow(
    categoryId: Int? = null,
    searchQuery: String? = null
): Flow<PagingData<LiveStream>> = Pager<Int, LiveStream>(
    config = PagingConfig(
        pageSize = PAGING_PAGE_SIZE,
        enablePlaceholders = false,
    ),
    pagingSourceFactory = {
        when (categoryId) {
            AllConst.FAV_CATEGORIES_ID.toInt() -> tvStreamsRepo.getFavoritesPagingSource()
            AllConst.ALL_CATEGORIES_ID.toInt() -> tvStreamsRepo.getStreamsAsPagingSource(categoryId = null, searchQuery)
            else -> tvStreamsRepo.getStreamsAsPagingSource(categoryId, searchQuery)
        }
    }
).flow.cachedIn(viewModelScope)


    fun getPagedLiveStreamsFlow(
        categoryIds: List<Int>? = null,
        searchQuery: String? = null
    ): Flow<PagingData<LiveStream>> = Pager<Int, LiveStream>(
        config = PagingConfig(
            pageSize = PAGING_PAGE_SIZE,
            enablePlaceholders = false,
        ),
        pagingSourceFactory = {
            when  {
                categoryIds.isNullOrEmpty() -> tvStreamsRepo.getStreamsAsPagingSource(categoryId =null, searchQuery)
                categoryIds.firstOrNull() ==AllConst.FAV_CATEGORIES_ID.toInt() -> tvStreamsRepo.getFavoritesPagingSource()
                else ->   tvStreamsRepo.getStreamsAsPagingSource(categoryIds, searchQuery)

            }
        }
    ).flow.cachedIn(viewModelScope)

    /**
     * checks weather the given stream is available in Favorites Table?
     * @property  stream stream item to be checked
     * @return Flow< Boolean> returns true if the stream is in favorites table otherwise false
     **/
    fun isFavoriteFlow(stream: BaseStream?) =
        tvStreamsRepo.isFavoriteAsFlow(stream?.streamId)
    /**
     * checks weather the given stream is available in Favorites Table?
     * @property  stream stream item to be checked
     * @return Boolean returns true if the stream is in favorites table otherwise false
     **/
    suspend fun isFavorite(stream: BaseStream) =
        withContext(Dispatchers.Default) {tvStreamsRepo.isFavorite(stream.streamId) }

    private val coroutineExceptionHandler = CoroutineExceptionHandler { _, throwable ->
        throwable.printStackTrace()
    }

    fun loadLiveStreams(username: String, password: String, serverUrl: String?): List<Job> {
        try {

            val apiService =
                createApiService("$serverUrl${SharedBuildKonfig.SERVER_API}", username, password)
            val streamsJob = viewModelScope.launch(Dispatchers.Default + coroutineExceptionHandler) {


                // val liveStreams = apiService.getVodStreams().body<String>()
                val streams = apiService.getLiveStreams()


                streams?.also { list ->

                    tvStreamsRepo.refreshData(list)




                }


            }
            val categoriesJob = viewModelScope.launch(Dispatchers.Default + coroutineExceptionHandler) {

                val categories = apiService.getLiveCategories()




                categories?.also { list ->

                    tvStreamsRepo.refreshCategories(list)

                }


            }

            return listOf(categoriesJob, streamsJob)
        } catch (e: Exception) {
            throw e
        }
        // onResponse.invoke()

    }

    suspend fun getLiveCategorySize(categoryId: Int?)=
        if (categoryId == AllConst.FAV_CATEGORIES_ID.toInt())
            tvStreamsRepo.favStreamsSize()
        else
            tvStreamsRepo.streamsSize(categoryId)
    fun insertWatched( stream: WatchedLiveStreams) {
        viewModelScope.launch(Dispatchers.Default) {
        watchedStreamsRepo.insert(stream) }}

}


